import React from 'react';
import styled, { css } from 'styled-components';
import {
  minBreakpointQuery,
  standardColours,
  brandColours,
  fontWeights,
  fontSize,
  standardTransition,
} from '../../styles';
import { Link } from './Link';
import { Svg } from './Svg';
import arrowIcon from '../../images/arrow-icon.inline.svg';

const commonButtonStyles = () => {
  return css`
    display: inline-block;
    padding: 10px 18px;
    color: ${standardColours.black};
    ${fontSize(12)};
    line-height: 1.6;
    text-align: center;
    background-color: ${({ alt }) =>
      alt ? brandColours.primary : standardColours.lightGrey};
    border-radius: 26px;
    transition: ${standardTransition('background-color')};

    &:hover {
      background-color: ${({ alt }) =>
        alt ? standardColours.lightGrey : brandColours.primary};

      ${StyledArrow} {
        fill: ${standardColours.black};
      }
    }

    ${minBreakpointQuery.small`
      padding-right 22px;
      padding-left 22px;
      ${fontSize(13)};
    `}

    ${minBreakpointQuery.large`
      padding-right: 26px;
      padding-left: 26px;
      ${fontSize(14)};
    `}

    ${({ alt }) => {
      if (alt) {
        return css`
          font-weight: ${fontWeights.bold};
        `;
      }
    }}
  `;
};

// moved up for hover
const StyledArrow = styled(Svg)`
  margin-left: 16px;
  width: 9px;
  fill: ${brandColours.primary};
  vertical-align: middle;
  transition: ${standardTransition('fill')};

  ${minBreakpointQuery.small`
    margin-left: 18px;
    width: 10px;
  `}

  ${minBreakpointQuery.large`
    margin-left: 20px;
    width: 11px;
  `}
`;

const StyledButton = styled.button`
  ${commonButtonStyles()};
  border: none;
`;

const StyledButtonLinkInternal = styled(Link)`
  ${commonButtonStyles()};
`;

const StyledButtonLinkExternal = styled.a`
  ${commonButtonStyles()};
`;

export const Button = ({ alt, children, ...props }) => {
  const ButtonComponent = props.to
    ? StyledButtonLinkInternal
    : props.href
    ? StyledButtonLinkExternal
    : StyledButton;

  return (
    <ButtonComponent alt={alt} {...props}>
      {children}
      {!alt && <StyledArrow image={arrowIcon} />}
    </ButtonComponent>
  );
};
